import React from "react";
import  { useState, useEffect } from 'react';
import './classes/EditAgentMessage.css';
import SalespersonSidebar from './SalespersonSidebar';
import Editor from 'react-simple-wysiwyg';
import { Link, useNavigate,useParams,useLocation } from 'react-router-dom';
import { configData } from "../config";
import { Helmet } from "react-helmet";
import Loading from './Loading';
import ViewAgentMessage from "./ViewAgentMessage";

const EditAgentMessage = () => {

    const initialEditAgentForm = {
        edit_agent_message_title: '',
        summary: '',
        body: '',
        id:''
    };

    const location  = useLocation();
    const [previewData, setPreviewData] = useState();
    const [toggle, setToggle] = useState(2);
    const [errors, setErrors] = useState({});
    const [showSummary, setShowSummary] = useState(false);
    const [useRichEditor, setUseRichEditor] = useState(true);
    const [PreviewFields, setPreviewFields] = useState(false);
    const [viewChanges,setViewChanges] = useState(false);
    const [formDataSnapshot, setFormDataSnapshot] = useState(null);
    const [originalData, setOriginalData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [formData, setFormData] = useState(initialEditAgentForm);
    const [savedData, setSavedData] = useState(initialEditAgentForm);
    const[userLoggedInRoles,setUserLoggedInRoles] = useState([]);

     const successMessage = location.state?.message; // Access the message
     window.history.replaceState({}, '');
    const navigate = useNavigate();
    var {tab} = useParams();
    const app_url = configData.APP_URL;
   
    const {aid} = useParams();

    const getPageTitle = () => {
        if (toggle === 1) {
            return savedData.edit_agent_message_title
                ? `${savedData.edit_agent_message_title}`
                : 'View';
        } else {
                return savedData.edit_agent_message_title
                ? `Edit Agent Message ${savedData.edit_agent_message_title}`
                : 'Edit Agent Message';
        }
    };
async function retrieveUserLoggedinroles() {
    
    
      try {
        setIsLoading(true);
    const response = await fetch(
      app_url+'viewprofile/getuserloggedinrolesid',
      {
        method: "GET",
  
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const responsedata = await response.json();
    if(responsedata.data.result === "Success") {
   setUserLoggedInRoles(responsedata.data.roles)
    }
     }  catch (error) {
            console.error('Error fetching data:', error);
          } finally {
           
          }
  
  }
    const onEditorChange = (field, e, isRich = true) => {
        let newHtml = e.target.value;

        // Normalize editor output
        const isEmptyHtml = newHtml.trim() === '' || newHtml === '<br>' || newHtml === '<p><br></p>';

        if (isEmptyHtml) {
            newHtml = '';
        } else if (isRich && !newHtml.trim().startsWith('<')) {
        // Wrap plain text in <p> if it's not already HTML
            newHtml = `<p>${newHtml}</p>`;
        }

        setFormData(prev => ({ ...prev, [field]: newHtml }));
    };

    const handleViewChangesClick = () => {
        setPreviewFields(false);
        const newErrors = {};

        if (!formData.edit_agent_message_title.trim()) {
            newErrors.edit_agent_message_title = 'Title field is required.';
        }

        setErrors(newErrors);

        if (Object.keys(newErrors).some(key => newErrors[key])) {
            setViewChanges(false); // Don't show view changes
            return;
        }

        setViewChanges(true);
        setOriginalData(savedData);
        setFormDataSnapshot(formData);
        window.scrollTo(0, 0);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const validateForm = () => {
        const newErrors = {};
        if (!formData.edit_agent_message_title.trim()) {
            newErrors.edit_agent_message_title = "Title field is required.";
        }
        return newErrors;
    };

    const inputStyle = {
        border: errors.edit_agent_message_title ? '2px solid red' : '1px solid #777',
    };

    const handlePreviewClick = () => {
        setViewChanges(false); 
        if (formData.edit_agent_message_title.trim()) {
            const bodyHtml = formData.body || '';
            const hasBreak = bodyHtml.includes('<!--break-->');
            const breakSummary = hasBreak ? bodyHtml.split('<!--break-->')[0] : null;

            const finalSummary = formData.summary?.trim() || breakSummary || '';

            setPreviewData({
                title: formData.edit_agent_message_title,
                summary: finalSummary,
                body: bodyHtml
            });

            setPreviewFields(true);
            setErrors(prev => ({ ...prev, edit_agent_message_title: null }));
            window.scrollTo(0, 0);
        } else {
            setErrors(prev => ({
                ...prev,
                edit_agent_message_title: "Title field is required."
            }));
            setPreviewFields(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        const validationErrors = validateForm();
        setErrors(validationErrors);
        if (Object.keys(validationErrors).length === 0) {
            const postData = formData;
             const response = await fetch(app_url + 'smwwagency/putagentmessage', {
                method: 'POST',
                body: JSON.stringify(postData),
                headers: {
                     'Content-Type': 'application/json',
             },
            });
            const data = await response.json();
             if(data.data.msg == "Success") {
                
                 navigate('/agent-message/'+aid+'/view', { state: { message: data.data.result } });
            } 
           
        }
    };

    // const handleSubmit = async event => {
    //     event.preventDefault();
    
    //     if (validate()) {
  
    //         const postData = formData;
    //         const response = await fetch(app_url + '', {
    //             method: 'POST',
    //             body: JSON.stringify(postData),
    //             headers: {
    //                 'Content-Type': 'application/json',
    //             },
    //         });
    //         const data = await response.json();
    //         if(data.data == "Success") {
        
    //             navigate('/manage-emails', { state: { message: data.data.result } });
    //         } 
        
       
    //     } else {
      
    //     }
    // };

    const updateToggle = (id) => {
        setToggle(id);
    
        if(id == 1) { 
        
            navigate("/agent-message/"+aid+"/view");
        }
        if(id == 2) { 
            navigate("/agent-message/"+aid+"/edit");
        }
     
        
    }

    useEffect(() => {
        Promise.all([
          retrieveEditAgentMessage(),
          retrieveUserLoggedinroles()
          
          ]).then(() => {
     
            setIsLoading(false);
             if(tab == "view") {
            setToggle(1);
        }
        if(tab == "edit") {
            setToggle(2);
        }
          })
       
       

       
     
    },[tab]);
    async function  retrieveEditAgentMessage() {
        const response = await fetch(
        app_url+'smwwagency/retrieveagentmessage?id='+aid,
            {
                method: "GET",
        
                headers: {
                'Content-Type': 'application/json',
                },
            }
        )
        const responsedata = await response.json();
        if(responsedata.data.msg == "Success") {
            const updatedForm = {
                edit_agent_message_title: responsedata.data.result.edittitle,
                summary: responsedata.data.result.editsummary,
                body: responsedata.data.result.editbody,
                id:aid
            };

            setFormData(updatedForm);
            setOriginalData(updatedForm); 

        }
    }

    const handleDelete = async () => {
        const confirmed = window.confirm("Are you sure you want to delete this message?");
        if (confirmed) {
            const response = await fetch(
        app_url+'smwwagency/deleteagentmessage?id='+aid,
            {
                method: "GET",
        
                headers: {
                'Content-Type': 'application/json',
                },
            }
        )
        const responsedata = await response.json();
        if(responsedata.data.msg == "Success") {
            navigate('/saadmin/manage-agent-message', { state: { message: responsedata.data.result } });
           
        }
        }
    };

    return (
        <>
            {isLoading ? (
                <Loading />
            ) : (
                <div id="main">
                    <Helmet>
                        <title>
                            {getPageTitle()}
                        </title>
                    </Helmet>
                    <div className="left"></div>
                    <div className="center left-center">
                        {(userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN)) &&
                        <>
                        {toggle === 2 && PreviewFields && (
                            <>
                                <div 
                                    className="messages status" 
                                    style={{ background: `#f0f8eb url("/basic/web/images/message-ok.png") no-repeat`,backgroundPosition: '10px 10px' }}
                                >
                                    The trimmed version of your post shows what your post looks like when promoted to the main page or when exported for syndication.
                                    <span>
                                        You can insert the delimiter "&lt;!--break--&gt;" (without the quotes) to fine-tune where your post gets split.
                                    </span>
                                </div>
                            </>
                        )}
                        {successMessage && (
                        <div className="set-message-done">
                          <span className="cart-message-icon message-icon"><i className="fa fa-check-circle"></i></span> {successMessage}
                        </div>
                        )}
                       
                        <div className='button_wrap'>
                             <ul className="tabs primarya">
                                <li className= {toggle === 1? "active" : ""} onClick={()=> updateToggle(1)}><a>View</a></li>
                                <li className= {toggle === 2? "active" : ""} onClick={()=> updateToggle(2)}><a>Edit</a></li>
                            </ul>      
                        </div>
                         </>
                        }
                        <div  className= {toggle === 1? "show-content" : "content"}>
                            <ViewAgentMessage savedData={savedData} />
                        </div>
                        {(userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN)) &&
                        <>
                        <div  className= {toggle === 2? "show-content" : "content"}>
                            <div className="edit-agent-message-container">
                                <div>
                                    {PreviewFields && (
                                        <>
                                            <div className="preview-container">
                                                <div className='preview-trimmed'>
                                                    <h4 className="preview-heading">
                                                        Preview trimmed version
                                                    </h4>
                                                    <div className="email-teaser">
                                                        <h2 className="email-title">
                                                            <a href="/full-email-page">{previewData?.title}</a>
                                                        </h2>
                                                        <div className="email-teaser-block1">
                                                            <div className="email-teaser-block2">
                                                                {previewData.summary && (
                                                                    <div dangerouslySetInnerHTML={{ __html: previewData.summary }} />
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div className="read-more-link">
                                                            <a href="/full-email-page">Read more</a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='preview-full'>
                                                    <h4 className="preview-heading">
                                                        Preview full version
                                                    </h4>

                                                    <div className="email-teaser">
                                                        <h2 className="email-title">
                                                            Body:
                                                        </h2>
                                                        <div className="email-teaser-block1">
                                                            <div className="email-teaser-block2">
                                                                <div dangerouslySetInnerHTML={{ __html: previewData.body }} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </div>
                                <div>
                                    {viewChanges && (
                                        <div className='diff-table-wrapper'>
                                            <table className="diff-table">
                                                <colgroup>
                                                    <col className="diff-marker" style={{width: "2%"}} />
                                                    <col className="diff-content" style={{width: "48%"}} />
                                                    <col className="diff-marker" style={{width: "2%"}} />
                                                    <col className="diff-content" style={{width: "48%"}} />
                                                </colgroup>
                                                <thead>
                                                    <tr>
                                                    <th colSpan="2">Original</th>
                                                    <th colSpan="2">Changes</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {!formDataSnapshot || !originalData ? (
                                                    <tr className="no-changes">
                                                        <td className="diff-section-title" colSpan="4">No visible changes</td>
                                                    </tr>
                                                    ) : (
                                                    (() => {
                                                        const diffs = [];

                                                    
                                                        const compareField = (label, oldValue = '', newValue = '') => {
                                                            if (oldValue === newValue) return null;

                                                            // Helper to strip style attributes from HTML tags
                                                            const stripStyles = (html) => {
                                                            return html.replace(/style="[^"]*"/gi, '');
                                                            };

                                                            // Split on block-level tags to get lines
                                                            const splitHtmlIntoLines = (html) => {
                                                            return html
                                                            .replace(/<\/(p|div)>/gi, '\n')
                                                            .replace(/<br\s*\/?>/gi, '\n')
                                                            .split('\n')
                                                            .map(line => line.trim())
                                                            .filter(Boolean);
                                                            };

                                                            // Strip styles from inputs
                                                            const oldClean = stripStyles(oldValue);
                                                            const newClean = stripStyles(newValue);

                                                            // Get lines
                                                            const oldLines = splitHtmlIntoLines(oldClean);
                                                            const newLines = splitHtmlIntoLines(newClean);
                                                            const maxLines = Math.max(oldLines.length, newLines.length);

                                                            if (oldLines.length === 0 && newLines.length === 0) return null;

                                                            const rows = [
                                                            <tr className="diff-section-title" key={`${label}-title`}>
                                                            <td colSpan="4">Changes to <em>{label}</em></td>
                                                            </tr>
                                                            ];

                                                            for (let i = 0; i < maxLines; i++) {
                                                            let oldLine = oldLines[i] || '';
                                                            let newLine = newLines[i] || '';

                                                            if (oldLine.trim() === '') oldLine = '-';
                                                            if (newLine.trim() === '') newLine = '-';

                                                            if (oldLine === newLine) continue;

                                                            // Tokenize line by splitting on tags and whitespace

                                                            const tokenize = (line) =>
                                                            line.split(/(<[^>]+>|\s+)/g).filter(token => token.trim() !== '');

                                                            const oldTokens = tokenize(oldLine);
                                                            const newTokens = tokenize(newLine);

                                                            const renderTokens = (tokensA, tokensB) =>
                                                            tokensA.map((token, idx) => {
                                                            const match = tokensB[idx] || '';
                                                            const changed = token !== match;
                                                            return (
                                                            <span
                                                            key={idx}
                                                            style={{
                                                            color: changed ? 'red' : undefined,
                                                            fontWeight: changed ? 'bold' : undefined,
                                                            padding: '0 2px',
                                                            whiteSpace: 'pre-wrap', 
                                                            }}

                                                            >
                                                            {token}
                                                            </span>
                                                            );
                                                            });

                                                            rows.push(
                                                            <tr key={`${label}-line-${i}`}>
                                                            <td>-</td>
                                                            <td className="diff-removed">{renderTokens(oldTokens, newTokens)}</td>
                                                            <td>+</td>
                                                            <td className="diff-added">{renderTokens(newTokens, oldTokens)}</td>
                                                            </tr>
                                                            );
                                                            }

                                                            return rows.length > 1 ? rows : null;
                                                        };



                                                        diffs.push(...(compareField('Title', originalData.edit_agent_message_title, formDataSnapshot.edit_agent_message_title) || []));
                                                        diffs.push(...(compareField('Summary', originalData.summary, formDataSnapshot.summary) || []));
                                                        diffs.push(...(compareField('Body', originalData.body, formDataSnapshot.body) || []));

                                                        return diffs.length > 0 ? diffs : (
                                                            <tr className="no-changes">
                                                                <td className="diff-section-title" colSpan="4">No visible changes</td>
                                                            </tr>
                                                        );
                                                    })()
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                </div>
                                <form onSubmit={handleSubmit}>
                                    <div>
                                        <div className="form-item">
                                            {errors.edit_agent_message_title && (
                                                <div 
                                                    className="form-error" 
                                                    style={{ background: `#fef5f1 url("/basic/web/images/message-24-error.png") no-repeat 2px`}}
                                                >
                                                    {errors.edit_agent_message_title}
                                                </div>
                                            )}
                                            <label htmlFor="edit-agent-message-title">
                                                Title  
                                                <span className="form-required" title="This field is required.*">*</span>
                                            </label>
                                            <input 
                                                className="edit-agent-message-title-field" 
                                                type="text" 
                                                id="edit-agent-message-title" 
                                                name="edit_agent_message_title" 
                                                maxLength={100} 
                                                onChange={handleChange}
                                                style={inputStyle} 
                                                // onChange={(e) => setFormData({ ...formData, edit_agent_message_title: e.target.value })}
                                                value={formData.edit_agent_message_title}
                                            />
                                        </div>
                                        <div className="editagentmessage-format-wrapper">
                                            <div>
                                                {showSummary && (
                                                    <div className="form-item">
                                                        <label htmlFor="edit_summary">
                                                            Summary <span>(<a className="" href="#" onClick={(e) => { e.preventDefault(); setShowSummary(false); }}>Hide Summary</a>)</span>
                                                        </label>
                                                        <>
                                                            <>
                                                                <Editor 
                                                                    containerProps={{ style: { resize: 'vertical' } }} 
                                                                    value={formData.summary} 
                                                                    onChange={e => onEditorChange('summary', e)}
                                                                />
                                                            </>
                                                        </>
                                                        <div className="description">Leave blank to use trimmed value of full text as the summary.</div>
                                                    </div>
                                                )}
                                        
                                                <div className="form-item">
                                                    <label htmlFor="edit_body">
                                                        Body 
                                                        {!showSummary && (
                                                            <span>
                                                                (<a href="#" onClick={(e) => { e.preventDefault(); setShowSummary(true); }}>
                                                                    Edit Summary
                                                                </a>)
                                                            </span>
                                                        )}
                                                    </label>
                                                    <>
                                                        {useRichEditor ? (
                                                            <> 
                                                                <Editor 
                                                                    containerProps={{ style: { resize: 'vertical', height:'300px' } }} 
                                                                    value={formData.body} 
                                                                    onChange={e => onEditorChange('body', e, true)}
                                                                />  
                                                                <a href="#" onClick={(e) => { e.preventDefault(); setUseRichEditor(false); }}>
                                                                    Switch to plain text editor
                                                                </a>
                                                            </>
                                                        ) : (
                                                            <>
                                                                <textarea
                                                                    id="edit_body"
                                                                    rows="20"
                                                                    value={formData.body} 
                                                                    onChange={e => onEditorChange('body', e, false)} 
                                                                />
                                                                <div 
                                                                    className="grippie" 
                                                                    style={{ background: `#eee url("/basic/web/images/grippie.png") no-repeat center 2px` }}
                                                                >
                                                                </div>
                                                                <a href="#" onClick={(e) => { e.preventDefault(); setUseRichEditor(true); }}>
                                                                    Switch to rich text editor
                                                                </a>
                                                            </>
                                                        )}
                                                    </>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-actions form-wrapper" id="edit-actions">
                                            <input 
                                                type="submit" 
                                                id="edit-submit" 
                                                name="" 
                                                value="Save" 
                                                className="form-submit" 
                                            />
                                            <input 
                                                type="button" 
                                                id="edit-preview"  
                                                value="Preview" 
                                                className="form-submit" 
                                                onClick={()=> {handlePreviewClick();}} 
                                            />
                                            <input 
                                                type="button" 
                                                id="view-changes"  
                                                value="View Changes" 
                                                className="form-submit" 
                                                onClick={()=> {handleViewChangesClick();}} 
                                            />
                                            <input 
                                                type="button" 
                                                id="edit-delete" 
                                                name="" 
                                                value="Delete" 
                                                className="form-submit" 
                                                onClick={handleDelete}
                                            />
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                       </>
                }
                    </div>
                    <div className="right">
                        <SalespersonSidebar />
                    </div>
                   
                </div>
            )}
        </>
    );
};
export default EditAgentMessage;